import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

import { NOTE_REMINDER_FRAGMENT } from '../fragment';

const QUERY = gql(
  `
    mutation UpdateNoteReminder(
      $updateNoteReminderData: UpdateNoteReminderInput!
    ) {
      updateNoteReminder(updateNoteReminderData: $updateNoteReminderData) {
        ...NoteReminderFields
      }
    }
  `,
  [NOTE_REMINDER_FRAGMENT]
);

export type Args = VariablesOf<typeof QUERY>['updateNoteReminderData'];

// TODO: This needs refactoring. We should not be appending the companyId to the query args
// However, the legacy logic piggybacks these values in so it can invalide the cache on mutation success
type OverScopedValues = {
  companyId: string;
};

export const mutationFn = async ({
  reminderId,
  noteId,
  eventBasedReminder,
  userTimezone,
  deliveryDate,
  customMessage,
}: Args & OverScopedValues) => {
  const { updateNoteReminder, errors } = await gqlClient.request(QUERY, {
    updateNoteReminderData: {
      reminderId,
      customMessage,
      deliveryDate,
      eventBasedReminder,
      noteId,
      userTimezone,
    },
  });

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return updateNoteReminder;
};
